import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-32 lg:py-44 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ac6a94503b5556d5813aa0e09fe9564d.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-brand-beige/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-8 lg:px-16 text-center">
        <span className="font-sans text-xs tracking-widest uppercase text-brand-gris-light mb-8 block">
          Collaborons ensemble
        </span>
        <h2 className="font-serif font-light text-brand-noir text-4xl lg:text-5xl xl:text-[54px] leading-tight mb-6">
          Vous souhaitez développer une identité visuelle forte ?
        </h2>
        <p className="font-sans font-light text-brand-gris text-lg leading-relaxed mb-12 max-w-2xl mx-auto">
          Contactez-nous pour discuter de votre projet. Chaque collaboration commence par une
          conversation.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 px-12 py-5 bg-brand-noir text-white font-sans text-sm tracking-widest uppercase hover:bg-brand-or transition-all duration-300 cursor-pointer whitespace-nowrap rounded-full"
        >
          Prendre contact
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      </div>
    </section>
  );
}
